
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-label":"close-svg"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('close')]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.087 4.52L1.1 9.505l1.414 1.415L7.5 5.933 6.087 4.52zm2.828 0l1.59-1.59L9.09 1.516 7.5 3.105 8.915 4.52z","fill":"#63756B"}}),_c('path',{attrs:{"fill":"#63756B","d":"M2.799 1.23l7.99 7.99-1.414 1.415-7.99-7.99z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.088 4.52l-4.83 4.83 1.414 1.414 4.83-4.83L6.088 4.52zm2.828 0l2.006-2.006L9.508 1.1 7.502 3.106 8.916 4.52z","fill":"#63756B"}})])
          )
        }
      }
    